import { FC } from "react";

export const PrivacyPolicyPage: FC = () => {
  return (
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-8">
      <h1 className="text-xl font-bold text-gray-700 mb-8">プライバシーポリシー</h1>
      <p className="text-md text-gray-700 mb-4">
        株式会社WeCanDoIt（以下「当社」といいます。）は、当社の提供するサービス（以下「本サービス」といいます。）における、
        ユーザーについての個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">1. 収集する利用者情報及び収集方法</h2>
      <p className="text-md text-gray-700 mb-4">
        本ポリシーにおいて、「利用者情報」とは、ユーザーの識別に係る情報、通信サービス上の行動履歴、その他ユーザーまたはユーザーの端末に関連して
        生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味するものとします。
        本サービスにおいて当社が収集する利用者情報は、その収集方法に応じて、以下のようなものとなります。<br /><br />
        (1) ユーザーからご提供いただく情報<br />
        本サービスを利用するために、または本サービスの利用を通じてユーザーからご提供いただく情報は以下のとおりです。<br />
        ・氏名、生年月日、性別、職業等プロフィールに関する情報<br />
        ・メールアドレス、電話番号、住所等連絡先に関する情報<br />
        ・クレジットカード情報、銀行口座情報、電子マネー情報等決済手段に関する情報<br />
        ・ユーザーの肖像を含む静止画情報<br />
        ・入力フォームその他当社が定める方法を通じてユーザーが入力または送信する情報<br /><br />
        (2) ユーザーが本サービスの利用において、他のサービスと連携を許可することにより、当該他のサービスからご提供いただく情報<br />
        ユーザーが、本サービスを利用するにあたり、ソーシャルネットワーキングサービス等の他のサービスとの連携を許可した場合には、その許可の際に
        ご同意いただいた内容に基づき、以下の情報を当該外部サービスから収集します。<br /><br />
        ・当該外部サービスでユーザーが利用するID<br />
        ・その他当該外部サービスのプライバシー設定によりユーザーが連携先に開示を認めた情報<br /><br />
        (3) ユーザーが本サービスを利用するにあたって、当社が収集する情報<br />
        当社は、本サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。<br />
        ・リファラ<br />
        ・IPアドレス<br />
        ・サーバーアクセスログに関する情報<br />
        ・Cookie、ADID、IDFAその他の識別子<br /><br />
        (4) ユーザーが本サービスを利用するにあたって、当社がユーザーの個別同意に基づいて収集する情報<br />
        当社は、ユーザーが個別に同意した場合、位置情報を利用中の端末から収集します。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">2. 利用目的</h2>
      <p className="text-md text-gray-700 mb-4">
        本サービスのサービス提供にかかわる利用者情報の具体的な利用目的は以下のとおりです。<br />
        <br />
        (1) 本サービスに関する登録の受付、本人確認、ユーザー認証、ユーザー設定の記録、利用料金の決済計算等本サービスの提供、維持、保護及び改善のため<br />
        (2) ユーザーのトラフィック測定及び行動測定のため<br />
        (3) 広告の配信、表示及び効果測定のため<br />
        (4) 本サービスに関するご案内、お問い合わせ等への対応のため<br />
        (5) 本サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため<br />
        (6) 本サービスに関する規約等の変更などを通知するため
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">3. 利用中止要請の方法</h2>
      <p className="text-md text-gray-700 mb-4">
        ユーザーは、本サービスの所定の設定を行うことにより、利用者情報の全部または一部についてその収集又は利用の停止を求めることができ、この場合、
        当社は速やかに、当社の定めるところに従い、その利用を停止します。 なお利用者情報の項目によっては、その収集または利用が本サービスの前提となるため、
        当社所定の方法により本サービスを退会した場合に限り、当社はその収集又は利用を停止します。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">4. 情報収集モジュールの有無</h2>
      <p className="text-md text-gray-700 mb-4">
        当社では、以下の情報収集モジュールを利用する場合があります。
        これに伴い、本サービスのアクセス状況及び利用状況などのデータを情報収集モジュール提供者（データの保存場所が日本国外にある場合を含みます。）へ送信し、
        サービス改良のための解析を行う場合があります。これらの情報収集モジュールでは、特定の個人を識別しない形で本サービスの利用に関する情報を収集しており、
        当該情報が利用者を特定するために使用されることはありません。<br /><br />
        情報収集モジュールの名称：Googleアナリティクス<br />
        情報収集モジュールの提供者：グーグル合同会社<br />
        上記提供者のプライバシーポリシーのURL: https://policies.google.com/privacy
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">5. 第三者提供</h2>
      <p className="text-md text-gray-700 mb-4">
        当社は、利用者情報のうち、個人情報については、あらかじめユーザーの同意を得ないで、第三者（日本国外にある者を含みます。）に提供しません。
        但し、次に掲げる必要があり第三者（日本国外にある者を含みます。）に提供する場合はこの限りではありません。<br /><br />
        (1) 当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合<br />
        (2) 合併その他の事由による事業の承継に伴って個人情報が提供される場合<br />
        (3) 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
        ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合<br />
        (4)
        本サービスの利用に関してクレジットカード等を用いた不正決済の疑いが発覚した際に、不正利用調査・犯罪捜査への協力を目的として、
        当社が契約する決済代行会社、クレジットカード会社等に対して、当該不正行為の内容等の利用者情報を提供する必要がある場合<br />
        (5)
        クレジットカード会社が提供する本人認証サービス「3Dセキュア」をユーザーがご利用の際に、当社が契約する決済代行会社を経由して
        ご利用のクレジットカード会社に住所、電話番号、メールアドレス等の利用者情報を相当な範囲で提供する必要がある場合<br />
        (6) 広告配信対象の指定（対象からの除外を含む。）のために、提携広告事業者に対して、同事業者のユーザーリストとユーザー情報を
        照合するための情報（ユーザーのメールアドレス等をハッシュ化したデータ）を提供する必要がある場合<br />
        (7) その他、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他の法令で認められる場合
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">6. 個人情報の開示</h2>
      <p className="text-md text-gray-700 mb-4">
        当社は、ユーザーから、個人情報保護法の定めに基づき個人情報の開示を求められたときは、ユーザーご本人からのご請求であることを確認の上で、
        ユーザーに対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、
        当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり1,000円）を頂戴しておりますので、あらかじめ御了承ください。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">7. 個人情報の訂正及び利用停止等</h2>
      <p className="text-md text-gray-700 mb-4">
        7-1
        当社は、ユーザーから、(1)個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、
        及び(2)あらかじめ公表された利用目的の範囲を超えて取扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、
        個人情報保護法の定めに基づきその利用の停止を求められた場合には、ユーザーご本人からのご請求であることを確認の上で遅滞なく必要な調査を行い、
        その結果に基づき、個人情報の内容の訂正または利用停止を行い、その旨をユーザーに通知します。なお、訂正または利用停止を行わない旨の決定をしたときは、
        ユーザーに対しその旨を通知いたします。<br /><br />
        7-2 当社は、ユーザーから、ユーザーの個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、
        ユーザーご本人からのご請求であることを確認の上で、個人情報の消去を行い、その旨をユーザーに通知します。<br />
        <br />
        7-3 個人情報保護法その他の法令により、当社が訂正等または利用停止等の義務を負わない場合は、7-1および7-2の規定は適用されません。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">8. お問い合わせ窓口</h2>
      <p className="text-md text-gray-700 mb-4">
        ご意見、ご質問、苦情のお申出その他利用者情報の取扱いに関するお問い合わせは、下記の窓口までお願いいたします。<br /><br />
        住所：〒179-0084 東京都練馬区氷川台3-39-5 森田ビル1階<br />
        株式会社WeCanDoIt<br />
        個人情報取扱責任者: 大里健祐<br />
        連絡先：contact@wcdi.co.jp
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">9. プライバシーポリシーの変更手続</h2>
      <p className="text-md text-gray-700 mb-4">
        当社は、必要に応じて、本ポリシーを変更します。但し、法令上ユーザーの同意が必要となるような本ポリシーの変更を行う場合、変更後の本ポリシーは、
        当社所定の方法で変更に同意したユーザーに対してのみ適用されるものとします。なお、当社は、本ポリシーを変更する場合には、
        変更後の本ポリシーの施行時期及び内容を当社のウェブサイト上での表示その他の適切な方法により周知し、またはユーザーに通知します。
      </p>
      <h2 className="text-md font-bold text-gray-700 mt-8 mb-4">【2022年12月9日 制定】</h2>
    </div>
  );
};
